import React from 'react'
import styled from 'styled-components'
import {
  Html as LibHtml,
  useUIFunctions,
  useConfigState,
  Link,
  useIsAuthenticated,
} from '@sentecacommerce-theme/lib'
import { HtmlProps } from './html.props'
import { Copy, Heading } from '../Common'

export const Html = ({ content, title, customUrls }: HtmlProps) => {
  const { enqueueView } = useUIFunctions()
  const config = useConfigState()
  const { isAuthenticated } = useIsAuthenticated()

  return (
    <LibHtml containerClasses="container">
      {title && <Heading data={title} topTitle />}
      <Copy html={content} />

      <div className="mt-3">
        {customUrls?.map((item) => {
          if (!item.shouldAuthenticate) {
            return (
              <Link href={item.url as string}>
                <LinkText>{item.text}</LinkText>
              </Link>
            )
          }

          if (item.shouldAuthenticate && !isAuthenticated) {
            return (
              <LinkText onClick={() => enqueueView(config.views.auth)}>
                <b>{item.text}</b>
              </LinkText>
            )
          }

          if (item.shouldAuthenticate && isAuthenticated) {
            return (
              <Link href={item.url as string}>
                <LinkText>
                  <b>{item.text}</b>
                </LinkText>
              </Link>
            )
          }
        })}
      </div>
    </LibHtml>
  )
}

const LinkText = styled.a.attrs({
  className: 'pb-3',
})`
  display: block;
  color: ${({ theme }) => theme.palette.silverTree};
  cursor: pointer;
`
